module.exports = __webpack_public_path__ + "img/mapNoImage.a2140b0d.png";